import React, { createContext, useContext } from 'react';
import { playSound } from '../utils/sound';
import useSoundStore from '../stores/soundStore';

const SoundContext = createContext();

export const useSoundContext = () => {
	const context = useContext(SoundContext);
	if (!context) {
		throw new Error('useSoundContext must be used within a SoundProvider');
	}
	return context;
};

export const SoundProvider = ({ children }) => {
	const isSoundEnabled = useSoundStore(state => state.isEnabled);
	const toggle = useSoundStore(state => state.toggle);

	const toggleSound = () => {
		toggle();
	};

	const play = (soundName) => {
		playSound(soundName, isSoundEnabled);
	};

	return (
		<SoundContext.Provider value={{ isSoundEnabled, toggleSound, play }}>
			{children}
		</SoundContext.Provider>
	);
};

export default SoundContext; 